import React from "react";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { IUser } from "../../../user/model/User";
import { PlusOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { Button, Col, List, Row } from "antd";
import CaseDecisionListItem from "./CaseDecisionListItem";
import { ICourtCase } from "../../../caseLawDocuments/model/CourtCase";
import { TCaseDecisionPresentationModel } from "../../presenter/model/CaseDecisionPresentationModel";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import { IDocumentTypeIndexCategory } from "../../../documentTypes/model/DocumentTypeIndexCategory";
interface CaseDecisionListProps {
  translate: any;
  caseDecisionList: TCaseDecisionPresentationModel[];
  referenceLoader?: boolean;
  createCaseDecision: any;
  findCourtCaseDetails: any;
  courtCase?: ICourtCase;
  getAllCaseDecisionTypeIndexes: (caseDecisionTypeId: number) => void;
  setCaseDecisionTypeId: (caseDecisionTypeId: number) => void;
  setOrganisationId: (organisationIndexId: number) => void;
  selectedOrganisationId?: number;
  organisations: IOrganisation[];
  caseDecisionTypes: IDocumentType[];
  caseDecisionTypeOrganisationIndex: IDocumentTypeIndexCategory[];
  selectedCaseDecisionTypeId?: number;
  selectedOrganisationIndexIds: number[];
  user?: IUser;
  createModalVisible: boolean;
  onChangeCreateModalVisible;
  showCaseDecisionDetails;
  store;
  showCaseDecisionCreation;
}
const CaseDecisionList: React.FC<CaseDecisionListProps> = ({
  translate,
  caseDecisionList,
  user,
  showCaseDecisionDetails,
  showCaseDecisionCreation
}) => {
  return (
    <div>
      <Row className={"search-result"}>
        <Col xs={24} sm={24}>
          <Title level={4}>
            {translate("editors.case_decisions.create_modal_title")}
          </Title>
          <Text>Prikazani su svi unosi.</Text>
        </Col>
      </Row>
      <Row className={"datagrid-header"}>
        <Col
          sm={24}
          style={
            user?.isUser()
              ? { display: "none" }
              : { textAlign: "right", paddingTop: 20 }
          }
        >
          <Button
            style={{ textAlign: "right" }}
            className="datagrid-add-btn"
            type={"primary"}
            icon={<PlusOutlined />}
            onClick={() => showCaseDecisionCreation()}
          >
            {translate("editors.case_decisions.add_new_text")}
          </Button>
        </Col>
      </Row>
      <List
        size="large"
        locale={{
          emptyText: translate("data_grid.empty_text")
        }}
        pagination={{
          hideOnSinglePage: caseDecisionList.length < 10,
          pageSize: 10,
          showSizeChanger: true,
          total: caseDecisionList.length,
          position: "top",
          showTotal: (total, range) => (
            <Text style={{ position: "absolute", left: 0 }}>{`${translate(
              "data_grid.pagination.showing"
            )} ${range[0]} ${translate("data_grid.pagination.to")} ${
              range[1]
            } ${translate("data_grid.pagination.total")} ${total}`}</Text>
          )
        }}
        dataSource={caseDecisionList}
        renderItem={(item) => (
          <CaseDecisionListItem
            item={item}
            translate={translate}
            showCaseDecisionDetails={showCaseDecisionDetails}
          />
        )}
      />
    </div>
  );
};
export default CaseDecisionList;
